// @flow strict

import type { MessageBusRoutingKey } from './types'

/**
 * https://geniussports.atlassian.net/wiki/spaces/UD/pages/191696141/RFC+Inter+widget+and+page+messaging
 */
export function doRoutingKeysMatch (listenerRoutingKey: MessageBusRoutingKey, messageRoutingKey: MessageBusRoutingKey): boolean {
  if (Object.keys(messageRoutingKey).length === 0 &&
        Object.keys(listenerRoutingKey).length === 0) return true

  if (listenerRoutingKey.hasOwnProperty('*')) return true

  if (Object.keys(messageRoutingKey).length > 0 &&
        Object.keys(listenerRoutingKey).length === 0) return false

  const listenerRoutingKeys = Object.keys(listenerRoutingKey)

  const nonMatches = listenerRoutingKeys.filter((rkKey: string) => {
    if (listenerRoutingKey[rkKey] === '*' && messageRoutingKey.hasOwnProperty(rkKey)) {
      return false
    } else if (messageRoutingKey.hasOwnProperty(rkKey)) {
      return messageRoutingKey[rkKey] !== listenerRoutingKey[rkKey]
    } else {
      return true
    }
  }
  )
  return !(nonMatches.length > 0)
}




// WEBPACK FOOTER //
// ./src/main/javascript/genius-sports-message-bus/MessageRouting.js